import api from "./api";
import { toast } from "react-toastify";
class PaymentService {
  async createPayment(data) {
    try {
      const response = await api.post("/payments/new-payment/", data);
      if (response.data.success) {
        return response.data.response;
      } else throw new Error(response.data.response);
    } catch (error) {
      toast.error(error.message);
      return false;
    }
  }
  async getPayers() {
    try {
      const response = await api
        .get("/payments/get-payers/")
        .then((res) => res.data);
      if (response.success) {
        const payers = response.response;
        payers.map((type) => {
          type.id = type.payer_type;
          type.name = type.payer_type;

          type.payer_details.map((payer) => {
            payer.id = payer.bp_payer_id.toString();
            payer.name = payer.payer_name;
            return payer;
          });
          return type;
        });
        return payers;
      } else throw new Error(response.response);
    } catch (error) {
      toast.error(error.message);
      console.log(error);
      return false;
    }
  }
  async getTpas() {
    try {
      const response = await api
        .get("/payments/get-tpas/")
        .then((res) => res.data);
      if (response.success) {
        const tpas = response.response;
        tpas.map((tpa) => {
          tpa.id = tpa.tpa_id.toString();
          tpa.name = tpa.tpa_name;
          return tpa;
        });
        return tpas;
      } else throw new Error(response.response);
    } catch (error) {
      toast.error(error.message);
      console.log(error);
      return false;
    }
  }
  async getPaymentModes() {
    try {
      const response = await api
        .get("/payments/get-payment-modes/")
        .then((res) => res.data);
      if (response.success) {
        return response.response;
      } else throw new Error(response.response);
    } catch (error) {
      toast.error(error.message);
      console.log(error);
      return false;
    }
  }
}
const paymentService = new PaymentService();
export default paymentService;
